<template>
  <div>
    <div class="top">
      <h3>{{time}}</h3>
      <p>{{today}}</p>
    </div>
    <div class="top-center">
      <h3>电影票详情</h3>
      <div class="content">
        <div class="title">{{post.movie_name}}</div>
        <div class="day">日期及场次：{{post.movie_date}} {{week}} {{time}}</div>
        <div class="day">放映地址：{{post.address}}</div>
        <div class="title-seat">座位：</div>
        <div class="seat-wrapper">
          <span class="seat" v-for="(item,index) in seat" :key="index">{{item}}</span>
        </div>
        <div class="money">
          总价：
          <span>
            ￥
            <span class="num">{{total}}</span>
          </span>
        </div>
      </div>
      <h3 v-if="total!=0">支付方式</h3>
      <div class="payment-type" v-if="total!=0">
        <div class="item" :class="{'active':curs==2}" @click="curs=2"></div>
        <div class="item" :class="{'active':curs==1}" @click="curs=1"></div>
        <!-- <div class="item" :class="{'active':curs==5}" @click="curs=5"></div> -->
      </div>
      <div class="btn-group">
        <div class="back-btn" @click.self="goBack" v-if="total!=0">取消支付</div>
        <div class="ok" @click="goPay" v-if="total!=0">确认支付</div>
        <div class="ok2" @click="printTicket" v-if="total==0">打印取票</div>
      </div>
    </div>
    <div class="mask" v-if="warn!=''">
      <div class="mask-content">
        <div class="icon"></div>
        <p>{{warn}}</p>
      </div>
    </div>
    <div class="mold" v-if="pay_mold" @click="pay_mold=false">
      <div class="wechat_item">
        <div class="pay_text">
          <p>订单金额：￥{{total}}</p>
        </div>
        <div class="code_box">
          <qrcode :value="qrcode" :options="{ size: 300 }"></qrcode>
        </div>
        <div class="pay_text" v-if="curs==1">打开支付宝，扫描二维码支付</div>
        <div class="pay_text" v-if="curs==2">打开微信，扫描二维码支付</div>
        <div class="close" @click.stop="pay_mold=false"></div>
      </div>
    </div>
    <div class="footer">
      <p>
        <!-- 设备ID：{{deviceId}} -->
        <span class="tel">
          客服电话
          <span>25650850 25650860</span>
        </span>
      </p>
    </div>
    <div class="back" @click="quite">退出</div>
  </div>
</template>

<script>
import { setInterval, clearInterval, setTimeout } from "timers";

export default {
  name: "HelloWorld",
  data() {
    return {
      curs: 2,
      qrcode: "",
      select_num: 5,
      real_seat: [],
      select_seat: [],
      seatStatus: true,
      seat_info: "",
      deviceId: localStorage.deviceNum || "123456789",
      time: "",
      today: "",
      day: "",
      timer: "",
      cur: 0,
      listData: [],
      list: [],
      film_date_layout_id: "",
      movie_name: "",
      price: "",
      start_time: "",
      rowWidth: "auto",
      post: "",
      seat: [],
      week: "",
      total: "",
      pay_mold: false,
      warn: "",
      strReturn: "",
      ticket_no: "",
      printFlag: true,
      timer3: ""
    };
  },
  created() {
    this.post = JSON.parse(localStorage.film_post);
    this.seat = this.post.seat_names;
    this.order_id = this.$route.query.orderId;
    this.movie_name = this.$route.query.name;
    this.price = this.$route.query.price;
    this.start_time = this.$route.query.time;
    this.total = this.post.price_total;
    this.get_OrderInfo();
  },
  mounted() {
    this.getDay();

    if (this.timer == "") {
      this.timer = setInterval(() => {
        this.getDay();
      }, 10000);
    }
    var that = this;
    this.$once("hook:beforeDestroy", function() {
      clearInterval(that.timer);
      clearInterval(that.timer3);
    });
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    goBack() {
      this.$api
        .OrderCancelOrder(localStorage.api_token, this.order_id)
        .then(res => {
          if (res.status == 1) {
            this.$router.go(-1);
          }
        });
    },
    quite() {
      this.$api
        .OrderCancelOrder(localStorage.api_token, this.order_id)
        .then(res => {
          if (res.status == 1) {
            clearInterval(this.timer3);
            clearInterval(this.timer);
            this.$router.replace("/");
          }
        });
    },
    //创建订单并且轮询支付结果
    goPay() {
      var that = this;
      this.getOrderStatus();
      this.$api.PayOrder(this.order_id, this.curs).then(res => {
        if (res.status == 1) {
          

          // 如果不是支付宝，则展示付款二维码
          if (this.curs != 1) {
            this.qrcode = res.data.qrcode;
            this.pay_mold = true;
          } else {
            this.qrcode = res.data.qr_code;
            this.pay_mold = true;
          }
        } else {
          this.warn = res.msg;
          setTimeout(() => {
            this.warn = "";
            clearInterval(that.timer3);
            this.$router.push({
              path: "/"
            });
          }, 1500);
        }
      });
    },
    // 获取订单信息
    get_OrderInfo() {
      this.$api
        .OrderInfo(localStorage.getItem("api_token"), this.order_id)
        .then(res => {
          this.order_detail = res.data;
          this.ticket_list = res.data.ticket_list;
          let ticket_list = res.data.ticket_list;
          if (res.status == 1) {
            let ticket_no = [];

            for (var i in ticket_list[0].ticket_list) {
              ticket_no.push(ticket_list[0].ticket_list[i].ticket_no);
            }
            this.ticket_no = ticket_no;
          }
          let list = res.data.ticket_list;
          let str = [];
          for (let i in list) {
            for (let j in list[i].ticket_list) {
              str.push({
                cinema_name: this.order_detail.cinema_name,
                movie_name: this.order_detail.movie_name,
                movie_date: this.order_detail.movie_date,
                start_time: this.order_detail.start_time,
                class_name: list[i].class_name,
                seat_name: list[i].ticket_list[j].seat_name,
                ticket_no: list[i].ticket_list[j].ticket_no
              });
            }
          }

          str.forEach((res, key, index) => {
            if (index == 0) {
              this.strReturn =
                res.cinema_name +
                "," +
                res.movie_name +
                "," +
                res.movie_date +
                res.start_time +
                "," +
                res.seat_name +
                "," +
                res.ticket_no +
                "," +
                this.order_detail.order_no +
                ";";
            } else {
              this.strReturn +=
                res.cinema_name +
                "," +
                res.movie_name +
                "," +
                res.movie_date +
                res.start_time +
                "," +
                res.seat_name +
                "," +
                res.ticket_no +
                "," +
                this.order_detail.order_no +
                ";";
            }
          });
        });
    },
    printTicket() {
      if (this.printFlag) {
        this.printFlag = false;
        this.$api
          .PickupTicket(
            this.order_id,
            this.ticket_no,
            localStorage.getItem("api_token"),
            0
          )
          .then(ress => {
            if (ress.status == 1) {
              console.log(this.strReturn);
              // 获取机器内打印纸数
              var obj = jsObj.getPageStatus();
              var pageNum = obj.split(",")[1];
              if (Number(pageNum) >= this.ticket_list.length) {
                // 打印门票
                jsObj.PrintFilmTicket("1", this.strReturn);
                var obj = jsObj.getPageStatus();
                var num2 = Number(obj.split(",")[1]);
                var num3 = Number(obj.split(",")[2]);
                if (num2 < num3) {
                  this.$router.push({
                    path: "/success",
                    query: {
                      order_id: this.order_id,
                      type: 1
                    }
                  });
                } else {
                  this.$router.push({
                    path: "/success",
                    query: {
                      order_id: this.order_id,
                      type: 2
                    }
                  });
                }
              } else {
                this.warn = "纸张不足，请联系客服人员";
                setTimeout(() => {
                  this.warn = "";
                  this.$router.replace("/nopage");
                }, 1500);
              }
            } else {
              this.warn = ress.msg;
            }
          });
      }
    },
    getOrderStatus() {
      var that = this;
      if(this.timer3!=''){
        clearInterval(this.timer3)
      }
     this.$api.getOrderStatus(this.order_id).then(res => {
        this.order_status = res.data.order_status;

        if (res.data.order_status == 2) {
          this.pay_mold = false;
          this.warn = "支付成功";
          clearInterval(that.timer3);
          // 打印门票
          this.printTicket();
        } else if (res.data.order_status == 1) {
        } else {
          clearInterval(that.timer3);
          this.$router.replace({
            path: "/"
          });
        }
      });
      this.timer3 = setInterval(() => {
        this.$api.getOrderStatus(this.order_id).then(res => {
          this.order_status = res.data.order_status;

          if (res.data.order_status == 2) {
            this.pay_mold = false;
            this.warn = "支付成功";
            clearInterval(that.timer3);
            // 打印门票
            this.printTicket();
          } else if (res.data.order_status == 1) {
          } else {
            clearInterval(that.timer3);
            this.$router.replace({
              path: "/"
            });
          }
        });
      }, 1000);
    },
    getDay() {
      var day = new Date();
      var hours = day.getHours();
      hours = hours < 10 ? "0" + hours : hours;
      var min = day.getMinutes();
      min = min < 10 ? "0" + min : min;
      var month = day.getMonth() + 1;
      var days = day.getDate();
      var week = day.getDay();
      var strWeek = "";
      var weeks = "";
      switch (week) {
        case 0:
          strWeek = "星期日";
          weeks = "周日";
          break;
        case 1:
          strWeek = "星期一";
          weeks = "周一";
          break;
        case 2:
          strWeek = "星期二";
          weeks = "周二";
          break;
        case 3:
          strWeek = "星期三";
          weeks = "周三";
          break;
        case 4:
          strWeek = "星期四";
          weeks = "周四";
          break;
        case 5:
          strWeek = "星期五";
          weeks = "周五";
          break;
        case 6:
          strWeek = "星期六";
          weeks = "周六";
          break;
      }
      this.time = hours + ":" + min;
      this.day = month + "月" + days + "日 ";
      this.today = month + "月" + days + "日 " + strWeek;
      this.week = weeks;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  width: 100%;
  min-height: 1920px;
  height: 1920px;
  background: #f0f0f0;
  overflow: hidden;
  position: relative;
  padding-bottom: 165px;
  .top {
    padding: 68px 50px;
    color: #4d4d4d;
    font-size: 25px;
    height: 486px;
    position: relative;
    h3 {
      font-size: 70px;
      margin: 0;
    }
    .title {
      position: absolute;
      top: 100px;
      left: 55%;
      transform: translateX(-50%);
      font-size: 50px;
      font-weight: 500;
      letter-spacing: 3px;
    }
  }
  .titles {
    font-size: 60px;
    letter-spacing: 3px;
    color: #0c5193;
    text-align: left;
    margin: 85px 60px 50px;
  }
  .top-center {
    padding: 60px 50px;
    margin-top: -300px;
    position: relative;
    h3 {
      color: #005192;
      font-size: 50px;
      margin-bottom: 40px;
    }
    .content {
      background: #fff;
      position: relative;
      padding: 80px 50px 0px;
      border-radius: 14px;
      border: 1px solid #005192;
      position: relative;
      margin-bottom: 80px;
      &:after {
        content: "";
        width: 100%;
        height: 1;
        border-top: 1px dashed #005192;
        position: absolute;
        left: 0;
        bottom: 210px;
      }
      .title {
        font-size: 36px;
        color: #005192;
        font-weight: 600;
        margin-bottom: 44px;
      }
      .title-seat {
        font-size: 30px;
        color: #005192;
        font-weight: 600;
        margin-bottom: 14px;
      }
      .day {
        font-size: 30px;
        color: #005192;
        font-weight: 400;
        margin-bottom: 10px;
      }
      .name {
        font-size: 40px;
        overflow: hidden;
        color: #005192;
        font-weight: bold;
        padding-right: 120px;
        span {
          float: right;
          color: #454545;
        }
      }
      .money {
        text-align: right;
        padding: 120px 0px 72px;
        font-size: 30px;
        color: #000;
        span {
          font-size: 30px;
          color: #ff5a00;
          &.num {
            font-size: 48px;
            font-weight: 600;
          }
        }
      }
    }
  }
}
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  z-index: 999;
  transition: all ease-in-out 300ms;
  .mask-content {
    width: 600px;
    height: 384px;
    background: #fff;
    border-radius: 6px;
    padding: 65px;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .icon {
      width: 102px;
      height: 102px;
      background: url(.././assets/icon.png) no-repeat;
      background-size: cover;
      margin: 0 auto 80px;
    }
    p {
      color: #5c5c5c;
      font-size: 30px;
      text-align: center;
    }
  }
}
// 支付方式
.payment-type {
  overflow: hidden;
  .item {
    width: 310px;
    height: 128px;
    background: url(.././assets/wx.png) no-repeat;
    background-size: cover;
    display: inline-block;
    margin-right: 20px;
    &.active {
      background: url(.././assets/wx_c.png) no-repeat;
      background-size: cover;
    }
    &:nth-child(3) {
      margin-right: 0;
      background: url(.././assets/yl.png) no-repeat;
      background-size: cover;
      &.active {
        background: url(.././assets/yl_c.png) no-repeat;
        background-size: cover;
      }
    }
    &:nth-child(2) {
      background: url(.././assets/zfb.png) no-repeat;
      background-size: cover;
      &.active {
        background: url(.././assets/zfb_c.png) no-repeat;
        background-size: cover;
      }
    }
  }
}
.mold {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10000;

  .wechat_item {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 480px;
    height: 600px;
    background-color: #fff;
    padding: 57px 0px;
    border-radius: 6px;
    .code_box {
      width: 300px;
      height: 300px;
      margin: 55px auto 84px;

      img {
        width: 100%;
      }
    }

    .pay_text {
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      p {
        font-size: 30px;
      }
    }
    .close {
      position: absolute;
      bottom: -234px;
      left: 50%;
      transform: translateX(-50%);
      width: 109px;
      height: 231px;
      background: url(.././assets/close.png) no-repeat;
      background-size: cover;
      cursor: pointer;
    }
  }
}
.seated {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 30px 60px 30px;
  border-top: 1px dashed #005192;
  h3 {
    color: #000;
    font-size: 26px;
    margin-bottom: 15px;
  }
  p {
    color: #55555a;
    font-size: 26px;
  }
}
.seat {
  width: 158px;
  height: 60px;
  display: inline-block;
  color: #3e70b8;
  font-size: 30px;
  text-align: center;
  line-height: 60px;
  text-align: center;
  background: url(.././assets/seat.png) no-repeat;
  background-size: 100% 100%;
  margin: 0 8px 8px 0;
}
.btn-group {
  margin: 160px auto 0;
  text-align: center;
  .back-btn {
    display: inline-block;
    width: 330px;
    height: 98px;
    border: 1px solid #b95020;
    color: #b95020;
    border-radius: 49px;
    font-size: 30px;
    line-height: 96px;
    text-align: center;
    cursor: pointer;
    margin-right: 57px;
    margin-left: 40px;
  }
  .ok {
    width: 488px;
    height: 98px;
    line-height: 98px;
    background: #b95020;
    color: #fff;
    font-size: 30px;
    border-radius: 49px;
    text-align: center;
    cursor: pointer;
    display: inline-block;
  }
  .ok2 {
    width: 488px;
    height: 98px;
    line-height: 98px;
    background: #b95020;
    color: #fff;
    font-size: 30px;
    border-radius: 49px;
    text-align: center;
    cursor: pointer;
    display: block;
    margin: 0 auto;
  }
}
.back {
  width: 213px;
  height: 98px;
  line-height: 98px;
  box-shadow: 0px 4px 13px 0px rgba(185, 32, 80, 0.35);
  border-radius: 49px 0px 0px 49px;
  background: #fff;
  color: #b95020;
  font-size: 30px;
  text-align: center;
  position: fixed;
  top: 35%;
  right: 0;
  z-index: 998;
  font-weight: 500;
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 60px;
  font-size: 24px;
  width: 100%;
  p {
    color: #5a5a5a;
    font-size: 20px;
    overflow: hidden;
    vertical-align: middle;
    .tel {
      float: right;
      color: #1c78f7;
      font-size: 20px;
      display: inline-block;
      vertical-align: middle;
      span {
        margin-left: 10px;
        font-size: 34px;
        font-weight: 800;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Confirm.vue